export const su = {
  page: 'bg-gray-900 min-h-screen p-3',
  wrap: 'max-w-7xl mx-auto space-y-3',
  card: 'bg-gray-800/90 rounded-lg border border-gray-700/80',
  cardPad: 'p-3',
  title: 'text-lg font-semibold text-white flex items-center gap-1.5',
  subtitle: 'text-[11px] text-gray-400 leading-tight',
  label: 'block text-[11px] font-medium text-gray-400 mb-0.5',
  input:
    'w-full h-8 px-2.5 text-xs bg-gray-900/70 border border-gray-600 rounded-md text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500',
  textarea:
    'w-full min-h-[4rem] px-2.5 py-1.5 text-xs bg-gray-900/70 border border-gray-600 rounded-md text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500',
  btnPrimary:
    'inline-flex items-center justify-center gap-1.5 h-8 px-3 text-xs font-medium bg-blue-600 hover:bg-blue-500 text-white rounded-md transition shrink-0',
  btnGhost:
    'inline-flex items-center justify-center gap-1.5 h-8 px-3 text-xs font-medium bg-gray-700 hover:bg-gray-600 text-gray-200 rounded-md transition',
  th: 'px-2.5 py-1.5 text-left text-[10px] font-medium text-gray-400 uppercase tracking-wide whitespace-nowrap',
  thRight: 'px-2.5 py-1.5 text-right text-[10px] font-medium text-gray-400 uppercase tracking-wide whitespace-nowrap',
  td: 'px-2.5 py-1.5 text-xs text-white',
  icon: 'h-4 w-4',
  grid: 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2',
  toolbar: 'flex flex-wrap items-center gap-2',
  searchWrap: 'relative min-w-[180px] flex-1 max-w-xs',
  searchIcon: 'absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-gray-400 pointer-events-none',
  searchInput:
    'w-full h-8 pl-8 pr-3 text-xs bg-gray-900/70 border border-gray-600 rounded-md text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
  date: 'w-[9.5rem] shrink-0',
  tableHead: 'bg-gray-900/50',
  tableRow: 'hover:bg-gray-700/40',
  empty: 'px-3 py-6 text-center text-xs text-gray-500',
  stat: 'bg-gray-900/50 rounded-md px-2.5 py-1.5 border border-gray-700/60',
  statLabel: 'text-[10px] text-gray-400 uppercase tracking-wide',
  statValue: 'text-sm font-semibold text-white mt-0.5',
};
